import { Box, Button } from '@radix-ui/themes';

interface MockSignInWidgetProps {
  loading: boolean;
  onSignIn: () => void;
}

export default function MockSignInDialogButton({
  loading,
  onSignIn
}: MockSignInWidgetProps) {
  return (
    <Box width='360px'>
      <Button
        loading={loading}
        onClick={onSignIn}
        style={{ width: '100%' }}
      >
        Авторизоваться
      </Button>
    </Box>
  );
}
